export default __webpack_public_path__ + "8aa23ecc8e861a1790df143b3ddf4a60.svg";